import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ClearAll from "../ClearButton";

const toolbarHeight = 8;

function Toolbar({
  title,
  view,
  handleCalenderApi,
  isBlocking,
  variant = "calendar",
  Labels,
}) {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      width="100%"
      height={`${toolbarHeight}vh`}
      justifyContent={"space-between"}
      alignItems="center"
      paddingLeft={2}
      paddingRight={2}
    >
      <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
        <Button
          variant="outlined"
          aria-label="today"
          onClick={() => handleCalenderApi({ type: "today" })}
          size={variant === "protocol" ? "small" : "medium"}
          color="inherit"
        >
          {t("timeline.buttons.today")}
        </Button>

        <IconButton
          aria-label="previous"
          size="small"
          onClick={() => handleCalenderApi({ type: "goBack" })}
          sx={{ padding: 1 }}
        >
          <ArrowBackIosOutlinedIcon fontSize="small" />
        </IconButton>
        <IconButton
          aria-label="next"
          size="small"
          onClick={() => handleCalenderApi({ type: "goNext" })}
          sx={{ padding: 1 }}
        >
          <ArrowForwardIosOutlinedIcon fontSize="small" />
        </IconButton>

        <Typography variant={variant === "protocol" ? "subtitle2" : "h6"}>
          {title}
        </Typography>
      </Box>
      {variant === "protocol" ? (
        Labels
      ) : (
        <Box>
          <ClearAll />
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(_, value) => {
              if (value) handleCalenderApi({ type: value });
            }}
            aria-label="calendar view"
            size="small"
            color="primary"
            sx={{ marginLeft: 2 }}
          >
            <ToggleButton value="timeGridWeek" aria-label="week">
              {t("timeline.buttons.week")}
            </ToggleButton>
            <ToggleButton value="dayGridMonth" aria-label="month">
              {t("timeline.buttons.month")}
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleCalenderApi({ type: "save_calendar" })}
            disabled={!isBlocking}
            sx={{ marginLeft: 2 }}
          >
            {t("common.buttons.save")}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Toolbar;
